// extracted by mini-css-extract-plugin
export default {"liveLabel":"gRAjqAgwzPk4comb7t0B"};